import { render, staticRenderFns } from "./ElementPalette.vue?vue&type=template&id=309b2cc6&scoped=true&"
import script from "./ElementPalette.vue?vue&type=script&lang=ts&"
export * from "./ElementPalette.vue?vue&type=script&lang=ts&"
import style0 from "./ElementPalette.vue?vue&type=style&index=0&id=309b2cc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309b2cc6",
  null
  
)

export default component.exports